//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zkTable from 'vue-table-with-tree-grid';
import selectNodeModal from '../common-components/select-node-modal.vue';

export default {
    name: 'nodeList',
    components: {
        selectNodeModal,
        zkTable
    },
    data() {
        return {
            props: {
                stripe: false,
                border: true,
                showHeader: true,
                showSummary: false,
                showRowHover: true,
                showIndex: false,
                treeType: true,
                isFold: true,
                expandType: false,
                selectionType: false
            },
            columns: [
                {
                    label: '栏目名称',
                    prop: 'nodeName',
                    width: '400px'
                },
                {
                    label: '栏目索引',
                    prop: 'nodeIndexes',
                    minWidth: '50px'
                },
                {
                    label: '上升',
                    minWidth: '50px',
                    type: 'template',
                    template: 'up'
                },
                {
                    label: '下降',
                    prop: 'id',
                    minWidth: '50px',
                    type: 'template',
                    template: 'down'
                },
                {
                    label: '操作',
                    prop: 'id',
                    minWidth: '200px',
                    type: 'template',
                    template: 'action'
                }
            ],
            loading: false,
            saving: false,
            nodeTitle: '新增',
            showNodeEditModal: false,
            node: {},
            NodeRule: {
                nodeName: {
                    required: true,
                    message: '栏目名称',
                    trigger: 'blur'
                },
                nodeIndexes: {
                    required: true,
                    message: '栏目索引',
                    trigger: 'blur'
                }
            },
            showAddNodeModal: false
        };
    },
    methods: {
        getNodeList() {
            this.loading = true;
            this.$store
                .dispatch({
                    type: 'node/getAllNodes',
                    data: {}
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        editNode(node) {
            console.log(node);
            if (node.id != 0) {
                this.nodeTitle = '修改';
            }
            this.node = node;
            this.showNodeEditModal = true;
        },
        saveNode() {
            this.$refs.nodeForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    this.$store
                        .dispatch({
                            type: 'node/saveNode',
                            data: this.node
                        })
                        .then(() => {
                            this.loading = false;
                            this.showNodeEditModal = false;
                            this.getNodeList();
                        }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        delNode(node) {
            // this.$Modal.confirm({
            //     title: '删除确认',
            //     content: '您确定要删除' + node.nodeName + '吗？',
            //     onOk: () => {

            //     },
            //     onCancel: () => {}
            // });
            this.saving = true;
            this.$store.dispatch({
                type: 'node/delNode',
                id: node.id
            }).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: node.nodeName + '已删除'
                });
                this.getNodeList();
            }, (error) => {
                this.$Modal.error({
                    title: '删除提示'
                });
                this.$Message.destroy();
            }).finally(() => {
                this.saving = false;
            });

        },
        showAddNode() {
            this.showAddNodeModal = true;
        },
        addNode(node) {
            this.node.parentName = node.nodeName;
            this.node.parentId = node.id;
            this.showAddNodeModal = false;
        },
        up(node) {
            if (!this.hasPermission('Pages.ContentManage.Node.Edit')) {
                return;
            }
            this.loading = true;
            this.$store
                .dispatch({
                    type: 'node/up',
                    id: node.id
                })
                .then(() => {
                    this.loading = false;
                    this.getNodeList();
                });
        },
        down(node) {
            if (!this.hasPermission('Pages.ContentManage.Node.Edit')) {
                return;
            }
            this.loading = true;
            this.$store
                .dispatch({
                    type: 'node/down',
                    id: node.id
                })
                .then(() => {
                    this.loading = false;
                    this.getNodeList();
                });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getNodeList();
    },
    computed: {
        nodes() {
            return this.$store.state.node.nodes;
        }
    }
};
